import { app } from '../../../app';
import { Controller } from './saaspass-connect.controller';

app.component('companySaaspassConnect', {
    bindings: {
        companyId: '<',
        connectApplications: '<',
    },
    controller: Controller,
    templateUrl: require('./saaspass-connect.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/saaspass-connect.component.js